import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import mogiesSample1 from '../../common/images/dashboard/carousel/mogies-sample1.png';
import mogiesSample2 from '../../common/images/dashboard/carousel/mogies-sample2.png';
import mogiesSample3 from '../../common/images/dashboard/carousel/mogies-sample3.png';
import mogiesSample4 from '../../common/images/dashboard/carousel/mogies-sample4.png';
import styles from './MogiesCarouselSlide.module.css';

export interface MogiesCarouselSlideProps {
  mobileView: boolean;
  currentSlide: number;
}

export const MogiesCarouselSlide: React.FC<MogiesCarouselSlideProps> =
  props => {
    const [currentPNG, setCurrentPNG] = useState(1);
    const currentPNGRef = useRef(1);
    const history = useHistory();
    const goToMogies = () => {
      history.push('/platform/mogie');
    };

    useEffect(() => {
      const myfunc = setInterval(function () {
        if (currentPNGRef.current === 4) {
          currentPNGRef.current = 1;
          setCurrentPNG(currentPNGRef.current);
        } else {
          currentPNGRef.current += 1;
          setCurrentPNG(currentPNGRef.current);
        }
      }, 3500);
      return () => {
        clearInterval(myfunc);
      };
    }, []);

    return (
      <div
        className={styles.carouselBanner + ' w-full'}
        style={
          0 === props.currentSlide ? { display: 'block' } : { display: 'none' }
        }
      >
        <div
          className={
            styles.carouselContainer +
            ' w-full h-full flex xl:justify-between justify-center flex-wrap-reverse gap-2 md:gap-0 box-border lg:p-12 lg:py-10 xl:py-12 p-16 relative'
          }
          style={{
            background: '#000000',
            borderRadius: 16,
          }}
        >
          <div
            className={
              ' lg:w-1/2 w-full flex flex-col items-center lg:items-start box-border z-10 lg:text-left text-center'
            }
          >
            <div
              className={
                styles.collectionName +
                ' text-5xl lg:text-6xl xl:text-8xl mt-2 lg:mt-3 font-extrabold'
              }
            >
              MOGIES
            </div>
            <div className={'text-sm xl:text-base xl:pr-14 font-bold mb-5'}>
              Brought to you by Mogul and the animators of the Simpsons and King
              of the Hill. This collection celebrates the 100th anniversary of
              the erection of the Hollywood sign in Los Angeles.
              <br />
              <br />
              These handcrafted 1 of 1 Digital Collectibles are the first step
              in bringing moviemaking to the Metaverse.
            </div>
            <div className="w-full mt-auto flex items-center gap-2 box-border">
              <div
                aria-hidden
                className={
                  styles.learnButton +
                  ' w-full lg:w-5/6 h-10 lg:h-12 text-xs sm:text-sm	font-semibold	flex justify-center items-center cursor-pointer'
                }
                onClick={() => goToMogies()}
              >
                Take Me To Mogieland
              </div>
            </div>
          </div>
          <div className="md:w-1/2 w-full z-10 flex flex-col justify-center lg:items-end items-center">
            <div
              className={
                'lg:w-9/12 w-full h-full flex items-center justify-center'
              }
            >
              <img
                className={styles.logoSquarify}
                src={mogiesSample1}
                alt="mogiesSample1"
                style={
                  currentPNG === 1 ? { display: 'block' } : { display: 'none' }
                }
              />
              <img
                className={styles.logoSquarify}
                src={mogiesSample2}
                alt="mogiesSample2"
                style={
                  currentPNG === 2 ? { display: 'block' } : { display: 'none' }
                }
              />
              <img
                className={styles.logoSquarify}
                src={mogiesSample3}
                alt="mogiesSample3"
                style={
                  currentPNG === 3 ? { display: 'block' } : { display: 'none' }
                }
              />
              <img
                className={styles.logoSquarify}
                src={mogiesSample4}
                alt="mogiesSample4"
                style={
                  currentPNG === 4 ? { display: 'block' } : { display: 'none' }
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
